import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Accordion, AccordionTab } from 'primereact/accordion';
import Cookies from 'js-cookie';
import { Helmet } from 'react-helmet';
import Wrapper from '../layouts/Wrapper';
import BannerTemplate from '../components/BannerTemplate';
// import SectionsInfo from '../components/SectionsInfo';
import Spinner from '../components/Spinner';
import { getFaqPage } from '../store/actions/faqPage';
import arrowUp from '../assets/icons/arrow_down.svg';
import arrowUpBlue from '../assets/icons/arrow_down_blue.svg';
import removeHtmlTags from '../helpers/removeHtmlTags';
import { getFAQSchema } from '../utils/schema';

function Faq() {
  const dispatch = useDispatch();
  const lang = Cookies.get('i18next') || 'en';
  useEffect(() => {
    dispatch(getFaqPage());
  }, []);
  const { data: faqData, loading: faqLoading } = useSelector((state) => state.faqPage);
  // Schema 5: built from the same items the accordion renders below.
  const faqSchema = getFAQSchema(faqData?.frequentlyAskedQuestions?.data, lang);
  return (
    <Wrapper>
      {faqSchema && (
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(faqSchema)}
          </script>
        </Helmet>
      )}
      {(!faqLoading) ? (
        <div className="container small">
          <BannerTemplate
            title={faqData.frequentlyAskedQuestions.title[lang]}
            description={faqData.frequentlyAskedQuestions.content_title[lang]}
          />
          <div className="faq-page">
            {/* <SectionsInfo */}
            {/*  isFaq */}
            {/*  isSlider={false} */}
            {/*  isPartner={false} */}
            {/*  title="Frequently asked questions" */}
            {/*  description="Visit us for comprehensive check-ups and medical services. */}
            {/* Experience professional care
             and advanced diagnostics in a comfortable environment." */}
            {/* /> */}
            <Accordion
              collapseIcon={() => (
                <button className="accordion-collapse-btn" type="button">
                  <img src={arrowUp} alt="arrow up" />
                </button>
              )}
              expandIcon={() => (
                <button className="accordion-expand-btn" type="button">
                  <img src={arrowUpBlue} alt="arrow up" />
                </button>
              )}
              style={{ marginTop: 0 }}
              className="faq__accordion"
              activeIndex={0}
            >
              {faqData.frequentlyAskedQuestions.data.map((e) => (
                <AccordionTab
                  key={e.id}
                  contentClassName="faq__accordion-content"
                  className="accordion-tab"
                  headerClassName="accordion-header"
                  header={removeHtmlTags(e.question[lang])}
                >
                  <blockquote>
                    {removeHtmlTags(e.answer[lang])}
                  </blockquote>
                </AccordionTab>
              ))}
            </Accordion>
          </div>
          {/* <SectionsInfo */}
          {/*  isSlider={false} */}
          {/*  isPartner={false} */}
          {/*  title={data.laboratory.two_blog_title[lang]} */}
          {/*  description={removeHtmlTags(data.laboratory.two_blog_description[lang])} */}
          {/* /> */}
          {/* <CustomAccordion data={data.laboratoryServiceList} /> */}
        </div>
      ) : <Spinner width={100} height={100} />}
    </Wrapper>
  );
}

export default Faq;
